import axios from 'axios';
import dl from "../utils/device-language";
import { getNamespaceForRestaurant } from '../utils/mapEnv';

export const ENDPOINT = "https://api-ristoratori.mycia.it/statistics/v1/";
export const NEW_ANALYTICS = "https://logger.mycia.it/v2/logs/webapp";

var data = {
    "action": "",
    "attributes": [],
    "domain": window.location.origin,
    "lang": dl.getDeviceLanguage(),
    "metadata": {},
    "referrer": window.document.referrer,
    "start": Date.now(),
    "url": window.location.href,
    "user_agent": navigator.userAgent,
};

async function trackData(id, action, metadata) {
    data.action = action;
    data.metadata = metadata ?? Object.assign({}, metadata);
    data.attributes.push(getNamespaceForRestaurant(id));

    if (
        "production" === process.env.NODE_ENV &&
        "test" !== getNamespaceForRestaurant(id) &&
        ["aperolspritz", "averna", "braulio", "bulldog",
            "campari", "camparisoda", "crodinoxl", "espolon", "wild"].includes(getNamespaceForRestaurant(id))
    ) {
        try {
            let formdata = new FormData();
            formdata.append("ris_id", id);
            formdata.append("text", JSON.stringify(data));

            return await axios.post(ENDPOINT, formdata);
        } catch (err) {
            console.error(err);
        }
    } else {
        // eslint-disable-next-line no-console
        console.log(data);
    }

    return data;
}

async function buildData(id, token, action, metadata, hasOrders) {
    var dataV2 = {
        "data": {
            "type": "webapplog",
            "attributes": {
                "ris_id": id,
                "token": token,
                "action": action,
                "payload": {
                    "action": action,
                    "attributes": [getNamespaceForRestaurant(id), hasOrders ? "o&p" : "mcm"],
                    "domain": window.location.origin,
                    "lang": dl.getDeviceLanguage(),
                    "metadata": metadata ?? Object.assign({}, metadata),
                    "referrer": window.document.referrer,
                    "start": Date.now(),
                    "url": window.location.href,
                    "user_agent": navigator.userAgent
                }
            }
        }
    };

    if (
        "production" === process.env.NODE_ENV &&
        "test" !== getNamespaceForRestaurant(id)
    ) {
        try {
            return await axios.post(NEW_ANALYTICS, dataV2);
        } catch (err) {
            console.error(err);
        }
    } else {
        /* eslint-disable "no-console"*/
        console.log(dataV2);
    }

    return dataV2;
}

async function trackDataV2(id, token, action, metadata, hasOrders) {
    try {
        return await buildData(id, token, action, metadata, hasOrders);
    } catch (e) {
        return console.error(e);
    }
}

export { trackData, trackDataV2 };
